// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qluUC","label":"styles_label__1ruvx"};